import { PosIconProps, SvgWrapper } from 'src/svgs/SvgWrapper';

export function ChevronEndIcon(props: PosIconProps) {
  return (
    <SvgWrapper
      aria-label="ChevronStartIcon"
      fill="currentColor"
      {...props}
      viewBox="8 6 8 12"
      style={{ transform: 'scaleX(-1)' }}
    >
      <g transform="scale(-1, 1) translate(-24, 0)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.58398 15.6668L9.75048 16.9158L14.4155 11.9193L14.4125 11.9158L14.4155 11.9123L9.75048 6.91577L8.58398 8.16477L12.086 11.9158L8.58398 15.6668Z"
        />
        <rect width="2" height="10" transform="matrix(-1 0 0 1 17 7)" />
      </g>
    </SvgWrapper>
  );
}
